// Consentement cookies (CNIL) — Google Analytics n'est chargé qu'après accord explicite.
const KEY = "briouse_cookie_consent";
const GA_ID = "G-HKH0VD0KSC";
const SIX_MONTHS_MS = 182 * 24 * 3600 * 1000;

export function getConsent() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const c = JSON.parse(raw);
    if (!c.ts || Date.now() - c.ts > SIX_MONTHS_MS) {
      localStorage.removeItem(KEY);
      return null;
    }
    return c;
  } catch {
    return null;
  }
}

export function setConsent(analytics) {
  try {
    localStorage.setItem(KEY, JSON.stringify({ analytics: !!analytics, ts: Date.now() }));
  } catch { /* stockage indisponible */ }
  if (analytics) {
    loadGa();
    // La page courante n'a pas encore été comptée (GA absent avant le clic Accepter)
    sendPageView();
  }
}

export function sendPageView() {
  if (typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", {
    page_path: window.location.pathname + window.location.search,
    page_location: window.location.href,
    page_title: document.title,
  });
}

let gaLoaded = false;
export function loadGa() {
  if (gaLoaded || typeof window === "undefined") return;
  if (window.__BRIOUSE_STAGING__) return;  // STAGING : aucun tracking GA4
  gaLoaded = true;
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", GA_ID, { anonymize_ip: true, send_page_view: false });
  // Aucun page_view ici : envoyé par trackPageView (navigation) ou setConsent (clic Accepter)
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
}

/** À appeler au démarrage : recharge GA si le visiteur avait déjà accepté. */
export function initConsent() {
  const c = getConsent();
  if (c && c.analytics) loadGa();
}

/** Rouvre le bandeau (lien « Gérer les cookies » du footer). */
export function openCookieSettings() {
  window.dispatchEvent(new CustomEvent("briouse:cookie-settings"));
}
